import { createFileRoute, redirect } from "@tanstack/react-router";
import { firstAccessibleRoute } from "@/auth/roles";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    if (context.auth.status === "unauthenticated") {
      throw redirect({ to: "/login" });
    }
    const next = firstAccessibleRoute(context.auth.role);
    if (next) {
      throw redirect({ to: next });
    }
    // Залогінений, але без ролі — `_auth.tsx` покаже AccessDenied, не редіректимо в loop.
    throw redirect({ to: "/leads" });
  },
});
